"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwatchesSink = void 0;
const react_1 = require("react");
const React = require("react");
require("./swatches.less");
class SwatchesSink extends react_1.Component {
    render() {
        const colors = ["Navy", "White"];
        const states = ["", "Hover", "Active", "Selected"];
        return (React.createElement("div", { className: "swatches" },
            React.createElement("h2", null, "Swatches"),
            colors.map(color => {
                const colorName = color.toLowerCase();
                return (React.createElement("div", { className: "row", key: color },
                    React.createElement("div", { className: "title" }, color),
                    states.map(state => {
                        const stateName = state ? `--${state.toLowerCase()}` : "";
                        return (React.createElement("div", { className: `swatch`, key: state },
                            React.createElement("div", { className: "title" }, state || "Normal"),
                            React.createElement("div", { className: `inside ${colorName}-swatch${stateName}` },
                                React.createElement("div", { className: "spacer" }),
                                React.createElement("div", { className: "text" },
                                    "Text ",
                                    React.createElement("b", null, "Bold")),
                                React.createElement("div", { className: "text-2" },
                                    "Text 2 ",
                                    React.createElement("b", null, "Bold")))));
                    })));
            })));
    }
}
exports.SwatchesSink = SwatchesSink;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/kitchen-sink/swatches/swatches.tsx
// module id = 3680
// module chunks = 0